export type FormationStateValues = 'NOT_STARTED' | 'FINISHED' | 'ONGOING';

export const formationStates: FormationStateValues[] = [
  'FINISHED',
  'NOT_STARTED',
  'ONGOING',
];

enum FORMATION_STATES {
  NOT_STARTED = "Je n'ai pas encore entrepris cette formation",
  ONGOING = 'Je suis en cours de formation',
  FINISHED = "J'ai achevé cette formation",
}
export default FORMATION_STATES;
